(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-my-shade-service"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shadeInfo = {
      1: {
        name: 'day 1',
        image: 'https://cdn.shopify.com/s/files/1/0886/6385/1319/files/health-retreat-day-1-texture-swatch.png?v=1791525254'
      },
      2: {
        name: 'day 2',
        image: 'https://cdn.shopify.com/s/files/1/0886/6385/1319/files/health-retreat-day-2-texture-swatch.png?v=1791525244'
      },
      3: {
        name: 'day 3',
        image: 'https://cdn.shopify.com/s/files/1/0886/6385/1319/files/health-retreat-day-3-texture-swatch.png?v=1791525279'
      },
      4: {
        name: 'day 4',
        image: 'https://cdn.shopify.com/s/files/1/0886/6385/1319/files/health-retreat-day-4-texture-swatch.png?v=1791525267'
      }
    };

    const matches = {
      'very-fair:seamless': [{ day: 1, wear: 'your closest match for a very sheer peach-nude warmth that stays soft and natural on very fair skin.' }],
      'very-fair:golden': [
        { day: 1, wear: 'wear this for your most subtle, seamless everyday glow.' },
        { day: 2, wear: 'wear this when you want a warmer, more visible honey-golden holiday glow.' }
      ],
      'very-fair:bronzed': [
        { day: 1, wear: 'wear this for a believable, softly sun-kissed base.' },
        { day: 2, wear: 'wear this for a noticeably warmer and more bronzed finish without going too deep.' }
      ],
      'fair-medium:seamless': [
        { day: 2, wear: 'your best match for a healthy honey-golden glow that remains sheer on fair to medium skin.' },
        { day: 1, wear: 'wear this when you want less tint and a softer peach-nude glow.' }
      ],
      'fair-medium:golden': [{ day: 2, wear: 'your best match for a warm, healthy-looking honey-golden glow with a sheer skin-like finish.' }],
      'fair-medium:bronzed': [
        { day: 2, wear: 'wear this for a natural golden everyday glow.' },
        { day: 4, wear: 'wear this when you want a deeper post-beach bronze or use it strategically as a liquid bronzer.' }
      ],
      'olive:seamless': [{ day: 3, wear: 'your closest match: a sheer olive-golden tint that melts into olive undertones without looking green, orange or heavy.' }],
      'olive:golden': [
        { day: 3, wear: 'wear this for the most seamless olive-golden match.' },
        { day: 2, wear: 'wear this when you want your olive skin to look brighter, warmer and more golden.' }
      ],
      'olive:bronzed': [
        { day: 3, wear: 'wear this for a natural olive-based glow that looks like your skin.' },
        { day: 4, wear: 'wear this for a warmer, richer and more visibly bronzed finish.' }
      ],
      'medium-dark:seamless': [{ day: 4, wear: 'your best match for sheer warmth and luminosity that enhances medium to dark skin without looking ashy or masking your natural tone.' }],
      'medium-dark:golden': [{ day: 4, wear: 'your best match for a warm bronze glow that brings out the richness and radiance in medium to dark skin.' }],
      'medium-dark:bronzed': [{ day: 4, wear: 'your best match for a richer post-holiday bronze that remains sheer, glossy and skin-like.' }],
      'deep:seamless': [{ day: 4, wear: 'your best match for sheer warmth and luminosity on deep skin, with no pale or ashy cast.' }],
      'deep:golden': [{ day: 4, wear: 'your best match for a hydrated, warm golden-bronze glow that lets your natural depth remain visible.' }],
      'deep:bronzed': [{ day: 4, wear: 'your best match for a rich bronze glow that enhances depth and radiance without looking heavy.' }]
    };

    document.querySelectorAll('[data-fms]').forEach((root) => {
      const intro = root.querySelector('.fms__intro');
      const quiz = root.querySelector('[data-quiz]');
      const form = root.querySelector('[data-form]');
      const stepOne = root.querySelector('[data-step="1"]');
      const stepTwo = root.querySelector('[data-step="2"]');
      const nextButton = root.querySelector('[data-next]');
      const resultButton = root.querySelector('[data-result]');
      const resultPanel = root.querySelector('[data-result-panel]');
      const resultGrid = root.querySelector('[data-result-grid]');
      const offer = root.querySelector('[data-offer]');
      const addBothButton = root.querySelector('[data-add-both]');
      const cartStatus = root.querySelector('[data-cart-status]');
      const progressText = root.querySelector('[data-progress-text]');
      const progressBar = root.querySelector('[data-progress-bar]');
      let currentMatches = [];

      const setStep = (step) => {
        stepOne.hidden = step !== 1;
        stepTwo.hidden = step !== 2;
        progressText.textContent = `step ${step} of 2`;
        progressBar.style.width = step === 1 ? '50%' : '100%';
        const heading = root.querySelector(`[data-step="${step}"] legend`);
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      };

      const addItems = (items, applyDiscount) => {
        cartStatus.textContent = items.length > 1 ? 'adding your shades to cart…' : 'adding your shade to cart…';
        root.querySelectorAll('.fms__result-card button, [data-add-both]').forEach((button) => {
          button.disabled = true;
        });
        let destination = applyDiscount
          ? `/discount/${root.dataset.discountCode}?redirect=${encodeURIComponent(root.dataset.cartUrl)}`
          : root.dataset.cartUrl;
        items.slice().reverse().forEach((item) => {
          destination = `${root.dataset.cartAddUrl}?id=${encodeURIComponent(item.id)}&quantity=${item.quantity}&return_to=${encodeURIComponent(destination)}`;
        });
        window.location.assign(destination);
      };

      const renderResults = (recommendations) => {
        resultGrid.innerHTML = '';
        recommendations.forEach((recommendation, index) => {
          const shade = shadeInfo[recommendation.day];
          const card = document.createElement('article');
          card.className = 'fms__result-card';
          card.innerHTML = `
            <span class="fms__result-label">${index === 0 ? 'your best match' : 'your second way to wear it'}</span>
            <span class="fms__result-drop" style="background-image:url('${shade.image}')" aria-hidden="true"></span>
            <h3>${shade.name}</h3>
            <p>${recommendation.wear}</p>
            <button class="fms__button fms__button--secondary" type="button">add ${shade.name} to cart</button>
          `;
          card.querySelector('button').addEventListener('click', () => {
            addItems([{ id: Number(root.getAttribute(`data-day-${recommendation.day}`)), quantity: 1 }], false);
          });
          resultGrid.appendChild(card);
        });
        offer.hidden = recommendations.length !== 2;
      };

      root.querySelector('[data-start]').addEventListener('click', () => {
        intro.hidden = true;
        quiz.hidden = false;
        setStep(1);
        quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      form.addEventListener('change', () => {
        nextButton.disabled = !form.elements.tone.value;
        resultButton.disabled = !form.elements.finish.value;
      });

      nextButton.addEventListener('click', () => setStep(2));
      root.querySelector('[data-back]').addEventListener('click', () => setStep(1));

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const key = `${form.elements.tone.value}:${form.elements.finish.value}`;
        currentMatches = matches[key] || [];
        form.hidden = true;
        root.querySelector('.fms__progress').hidden = true;
        renderResults(currentMatches);
        resultPanel.hidden = false;
        resultPanel.focus();
        resultPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      addBothButton.addEventListener('click', () => {
        addItems(currentMatches.map((match) => ({ id: Number(root.getAttribute(`data-day-${match.day}`)), quantity: 1 })), true);
      });

      root.querySelector('[data-restart]').addEventListener('click', () => {
        form.reset();
        currentMatches = [];
        nextButton.disabled = true;
        resultButton.disabled = true;
        resultPanel.hidden = true;
        form.hidden = false;
        root.querySelector('.fms__progress').hidden = false;
        setStep(1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
